"use client";

import Error from "next/error";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";

import { ButtonLink } from "@/components/buttons/ButtonLink";
import { TextLink } from "@/components/links/TextLink";
import { Heading1 } from "@/components/text/Heading1";
import { OverHeading } from "@/components/text/OverHeading";
import { Preamble } from "@/components/text/Preamble";

// Error components must be Client Components

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const posthog = usePostHog();
  useEffect(() => {
    posthog.captureException(error);
  }, [error, posthog]);

  return (
    // global-error must include html and body tags
    <html lang="en">
      <body>
        <div className="flex flex-col justify-center px-4 pb-20 pt-36 text-center align-middle sm:px-6 lg:px-8">
          <OverHeading elementType="p">Error</OverHeading>
          <Heading1 className="mt-4" elementType="h1">
            Something went wrong!
          </Heading1>
          <Preamble className="mt-6">
            An error occurred; we apologize for any inconvenience.
          </Preamble>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <ButtonLink href="/" external={false}>
              Back to home
            </ButtonLink>
            <TextLink href="/contact" external={false}>
              Contact support →
            </TextLink>
          </div>
        </div>
      </body>
    </html>
  );
}
